// hooks/useTheme.ts
import { useEffect, useState } from "react";

export type Theme = "light" | "dark";
const KEY = "cs_theme";

export function getInitialTheme(): Theme {
    try {
        const saved = (localStorage.getItem(KEY) || localStorage.getItem("theme")) as Theme | null;
        if (saved === "light" || saved === "dark") return saved;
        return window.matchMedia && window.matchMedia("(prefers-color-scheme: dark)").matches
            ? "dark"
            : "light";
    } catch {
        return "light";
    }
}

export function applyTheme(theme: Theme) {
    if (typeof document === "undefined") return;
    const root = document.documentElement;
    if (theme === "dark") root.classList.add("dark");
    else root.classList.remove("dark");
}

export function useTheme() {
    const [theme, setTheme] = useState<Theme>(() => getInitialTheme());

    useEffect(() => {
        applyTheme(theme);
        try { localStorage.setItem(KEY, theme); } catch {}
    }, [theme]);

    // sync multi-onglets (facultatif mais pratique)
    useEffect(() => {
        const onStorage = (e: StorageEvent) => {
            if (e.key === KEY && (e.newValue === "light" || e.newValue === "dark")) {
                applyTheme(e.newValue);
            }
        };
        window.addEventListener("storage", onStorage);
        return () => window.removeEventListener("storage", onStorage);
    }, []);

    return { theme, setTheme };
}

/** Optionnel : le monter tôt (Layout/App) pour appliquer le thème dès le mount React */
export function ThemeBootstrap() {
    useEffect(() => {
        applyTheme(getInitialTheme());
    }, []);
    return null;
}
